import { render } from "./RegistSellStakeModal.vue?vue&type=template&id=30f23284&ts=true"
import script from "./RegistSellStakeModal.vue?vue&type=script&lang=ts"
export * from "./RegistSellStakeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__